import { render, staticRenderFns } from "./ResizeHeight.vue?vue&type=template&id=26afff46&"
import script from "./ResizeHeight.vue?vue&type=script&lang=ts&"
export * from "./ResizeHeight.vue?vue&type=script&lang=ts&"
import style0 from "./ResizeHeight.vue?vue&type=style&index=0&id=26afff46&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports